import { Link } from "react-router-dom";
import { ArrowRight, ScanLine, Ruler, FileCog } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1479292889369-1a48f234247e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const FEATURES = [
  { icon: ScanLine, title: "Elevation to material map", text: "Upload an elevation. AI marks out the zones, then you switch each one between ACP, HPL, solid metal, GFRC, jalli, glazing or curtain wall." },
  { icon: Ruler, title: "Engineered systems", text: "Semi-unitized curtain walls, skylights and canopies checked for wind (IS 875-3), deflection, stress, glass and anchors." },
  { icon: FileCog, title: "Fabrication output", text: "BOM, cutting lists, DXF shop drawings and PDF design reports, generated from the same model." },
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#09090b] text-zinc-100">
      <section className="relative overflow-hidden border-b border-zinc-800">
        <img src={HERO} alt="Glass curtain wall facade" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090b] via-[#09090b]/85 to-transparent" />
        <div className="relative mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-sky-500/30 bg-sky-500/10 px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-sky-300">
            Facade · Fenestration · Curtain Wall
          </div>
          <h1 className="max-w-3xl font-[Manrope] text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl animate-slide-up">
            Design the building envelope, <span className="text-sky-400">panel by panel.</span>
          </h1>
          <p className="mt-6 max-w-xl text-base text-zinc-300 md:text-lg">
            One studio for picking cladding materials, engineering curtain walls and producing fabrication drawings.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/dashboard" data-testid="landing-open-studio-btn"
              className="inline-flex items-center gap-2 rounded-md bg-sky-500 px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-sky-600">
              Open Studio <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/materials" data-testid="landing-catalog-btn"
              className="inline-flex items-center gap-2 rounded-md border border-zinc-700 px-6 py-3 text-sm font-semibold text-zinc-200 transition-colors duration-200 hover:border-zinc-500 hover:text-white">
              Material Catalog
            </Link>
          </div>
        </div>
      </section>
      <section className="mx-auto grid max-w-7xl gap-6 px-6 py-20 md:grid-cols-3 md:px-10">
        {FEATURES.map(({ icon: Icon, title, text }, i) => (
          <div key={title} className="rounded-lg border border-zinc-800 bg-[#121215] p-6 animate-slide-up" style={{ animationDelay: `${i * 90}ms` }}>
            <Icon className="mb-5 h-6 w-6 text-amber-400" />
            <h3 className="font-[Manrope] text-lg font-semibold">{title}</h3>
            <p className="mt-2 text-sm text-zinc-400">{text}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
